import type { ReactElement } from 'react';
import styles from './CharacterCounter.module.css';

/** A partir de quanto do limite o contador aparece (antes disso seria ruído). */
export const COUNTER_THRESHOLD = 0.8;

const formatCount = (n: number): string => n.toLocaleString('pt-BR');

/** O contador aparece perto do limite ou acima dele. */
export const showsCounter = (length: number, limit: number): boolean =>
  length >= limit * COUNTER_THRESHOLD;

/**
 * Contador de caracteres de um campo de nota. O número fica numa linha que o campo referencia por
 * `aria-describedby` (lida ao focar, sem falar a cada tecla). Acima do limite entra um aviso
 * `role="alert"` com texto FIXO: anunciado uma vez, ao passar do limite, e não a cada caractere
 * (um texto com o número mudaria a cada tecla e o leitor de tela repetiria tudo).
 */
export function CharacterCounter({
  id,
  length,
  limit,
}: {
  id: string;
  length: number;
  limit: number;
}): ReactElement | null {
  if (!showsCounter(length, limit)) return null;
  const over = length > limit;
  return (
    <>
      <p id={id} className={over ? styles.over : styles.counter}>
        {formatCount(length)} de {formatCount(limit)} caracteres
      </p>
      {over && (
        <p role="alert" className={styles.overAlert}>
          Passou do limite de {formatCount(limit)} caracteres. Reduza o texto para continuar.
        </p>
      )}
    </>
  );
}
